import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import PropertyDetail from "@/pages/PropertyDetail";
import Contact from "@/pages/Contact";
import Owner from "@/pages/Owner";
import ReviewPage from "@/pages/ReviewPage";
import Handout from "@/pages/Handout";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stay/:slug" element={<PropertyDetail />} />
          <Route path="/enquire" element={<Contact />} />
          <Route path="/owner" element={<Owner />} />
          <Route path="/review/:token" element={<ReviewPage />} />
          <Route path="/handout" element={<Handout />} />
          <Route path="/handout/:slug" element={<Handout />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
